<div
  #configurableTable
  id="{{ id }}-container"
  class="emds table-responsive-sm"
  [ngClass]="{ 'table-overflow-auto': !setStickyHeaders }"
>
  <table
    id="{{ id }}"
    class="table emds-table table-striped table-borderless mt-2 table-sticky-header table-fixed"
    [ngClass]="{ 'table-sticky-header': setStickyHeaders }"
  >
    <thead>
      <tr>
        <th *ngFor="let columnInfo of columnInfoListToShow"
          (click)="isSortableHeader(columnInfo) ? onSort(columnInfo) : null"
          [ngStyle]="getTableHeaderStyles(columnInfo)"
          [ngClass]="{
            'sortable-header': isSortableHeader(columnInfo),
            'sorted-header': sortColumn === columnInfo.ColumnName
           }">
          <!-- Translations with configurable headings will be an issue - looking into calling translate from ts code -->
          {{ columnInfo.HeaderDisplayName }}
    
          <ng-container *ngIf="isSortableHeader(columnInfo)">
            <mat-icon
              class="sort-icon"
              *ngIf="sortColumn === columnInfo.ColumnName"
            >
              {{ sortDirection === 'Ascending' ? 'arrow_upward' : 'arrow_downward' }}
            </mat-icon>
    
            <mat-icon class="sort-icon" *ngIf="sortColumn !== columnInfo.ColumnName">
              arrow_upward
            </mat-icon>
          </ng-container>
        </th>
      </tr>
    </thead>

    <tbody *ngFor="let group of (sortedDataItmLst ?? mainDataItmLst)">
      <tr *ngIf="group.GroupName?.length > 0">
        <td
          [attr.colspan]="columnInfoListToShow.length"
          class="table-group-header"
        >{{ group.GroupName }}</td>
      </tr>
      <ng-container *ngFor="let dataItem of group.GroupLst">
        <ng-container *ngIf="!dataItem.Deleted">
          <tr [class.cursor-pointer]="enableRowSelection" [class.text-bold]="selectedRow === dataItem" [ngClass]="dataItem.CssClass ? dataItem.CssClass : ''" (click)="selectRow(dataItem)" (mouseover)="addListerers()">
            <td
              *ngFor="let columnInfo of columnInfoListToShow"
              [ngStyle]="columnInfo.Format?.NgStyleProperties(dataItem)"
              [ngClass]="columnInfo.Format ? columnInfo.Format.AdditionalElementClasses : ''"
            >
              <ng-container [ngSwitch]="columnInfo.FieldTypeObject.FieldType">
                <ng-container *ngSwitchCase="ColumnFieldType.String">
                  <ap-column-string
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-string>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.Number">
                  <ap-column-number
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-number>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.Date">
                  <ap-column-date
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-date>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.DateTime">
                  <ap-column-date-time
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-date-time>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.HyperLink">
                  <ap-column-hyperlink
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-hyperlink>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.Dropdown">
                  <ap-column-dropdown
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-dropdown>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.Html">
                  <ap-column-html
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-html>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.TimeFrame">
                  <ap-column-timeframe
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-timeframe>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.Checkbox">
                  <ap-column-checkbox
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-checkbox>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.RadioButton">
                  <ap-column-radio-button
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-radio-button>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.ActionIcons">
                  <ap-column-action-icons
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-action-icons>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.FindControl">
                  <ap-column-findcontrol
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-findcontrol>
                </ng-container>
                <ng-container *ngSwitchCase="ColumnFieldType.ExtTimeframe">
                  <ap-column-ext-timeframe
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                  ></ap-column-ext-timeframe>
                </ng-container><ng-container *ngSwitchCase="ColumnFieldType.ExtFindcontrol">
                  <ap-column-ext-findcontrol
                    [baseId]="id"
                    [columnName]="columnInfo.ColumnName"
                    [columnInfoDto]="columnInfo.FieldTypeObject"
                    [dataItem]="dataItem"
                    (autoCompletePanelOpen)="setAutoCompletePanelOpen($event)"
                  ></ap-column-ext-findcontrol>
                </ng-container>
                <div
                  class="alert-warning"
                  *ngSwitchDefault
                  translate
                >Unknown table column type</div>
              </ng-container>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
</div>